export default function () {
    return {
        jobs: []
    }
}
